/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios";

export default {
  getDispenseRequests({ commit }, dataTableParams) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/dispense-request`, { params: dataTableParams })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPatientScripts({commit}, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/dispense-request/patient-scripts/${data.patientId}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createNewDispenseRequest({commit}, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/v1/dispense-request`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDispenseRequestFee({commit}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/dispense-request/fees`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
